import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FlyoutContext } from 'components/Flyout/FlyoutContext';
import { openModal, closeModal } from 'components/Modal';
import { reportError } from 'helpers/error-logging';
import { selectUserInfo } from 'selectors/general';

import { submitSkuMenuPricing } from './SkuItems.helpers';
import { ITEM_SUBMIT_ERROR_MODAL_NAME } from './components/ItemSubmitErrorModal';

const useSkuPricingSubmission = ({ venue, currencyCode, onSuccess, errorLabel = 'SKU Item' }) => {
  const dispatch = useDispatch();
  const { adminUserId } = useSelector(selectUserInfo);
  const isAdminUser = !!adminUserId;
  const { closeFlyout } = useContext(FlyoutContext);

  const handleSubmitPricing = useCallback(
    async ({ name, price, link }) => {
      if (isAdminUser) return true;

      try {
        await submitSkuMenuPricing(venue, { itemName: name, menuPrice: price, linkToMenu: link });
        return true;
      } catch (error) {
        reportError(`Could not submit menu pricing for ${errorLabel}`, error);
        onSuccess?.();
        closeFlyout();
        dispatch(closeModal());
        dispatch(
          openModal(ITEM_SUBMIT_ERROR_MODAL_NAME, {
            currencyCode,
            itemName: name,
            linkToMenu: link,
            menuPrice: price,
          })
        );
        return false;
      }
    },
    [isAdminUser, venue, currencyCode, onSuccess, closeFlyout, dispatch, errorLabel]
  );

  return { handleSubmitPricing };
};

export default useSkuPricingSubmission;
